"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function CheckboxTickIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M0,0h24v24H0V0z", fill: "none" }),
        react_1.default.createElement("path", { d: "M19.018,3H5A2.006,2.006,0,0,0,3,5V19a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V4.982A1.988,1.988,0,0,0,19.018,3ZM10.551,16.8a.85.85,0,0,1-1.2,0l-4.3-4.3,1.2-1.2L9.95,15l7.8-7.8,1.2,1.2Z" })));
}
exports.default = CheckboxTickIcon;
